<body class="transparent-header">

  <div class="header-nav">
    <div id="page-header" class="">
      <div class="text-align-center">
        <a [routerLink]="['/signinpage']">
          <img src="RNCloud_logo.png" alt="RNCloud" title="RNCloud">
        </a>
        <!--<a (click)="onSignUp()" class="btn btn-primary nav-link-hand float-right margin-left-37px">Register</a>-->
        <!--<a (click)="onSignIp()" class="btn btn-primary nav-link-hand float-right margin-top-10 margin-left-10px">Sign In</a>-->

      </div>
     
      <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!--<img src="../../../../../wwwroot/healins-assets/images/RNCloud_logo.png" />-->
      <div id="bs-example-navbar-collapse-1" class="collapse navbar-collapse">
        <ul class="nav navbar-right navbar-nav ml-auto">
          <!--<li><a  class="h-link active">Home</a></li>
      <li><a  class="h-link">How It Works?</a></li>
      <li><a  class="h-link">Features</a></li>
      <li><a  class="h-link">Pricing</a></li>-->
          <!--<li class="login"><a href="#mySignin" class="green-sign" data-toggle="modal" data-target="#myModal" data-backdrop="static">Sign In</a></li>
      <li class="signup"><a href="#mySignup" class="orange-sign" data-toggle="modal" data-target="#myModalSignup" data-backdrop="static">SIGN UP</a></li>*@-->
          <!--<li><a href="www.google.com  " class="green-sign">Sign In</a></li>-->
          <!--target="_self"-->
          <!--<li><a (click)="onlogin()" class="green-sign">Sign In</a></li>-->
          <li><a (click)="onSignIp()" class="green-sign nav-link-hand">Sign In</a></li>
          <li><a (click)="onSignUp()" class="orange-sign nav-link-hand">Register</a></li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Sliders New Section Start -->
  <div class="main-slider container-fluid">
    <!--<div id="linearBg1"></div>-->
    <div class="row">
     
      <div class="col-md-7 background-image  margin-lr-auto">
        <div class="card">
          <div class="header-nrh font-color">Register with RnCloud</div>
          <div class="card-body border-bottom">
            <div class="row margin-bottom-20px">
              <div class="col-md-4 border-right text-align-center">
                <a (click)="onSignUp()" class="nav-link-hand">
                  <i class="fas fa-user-circle icon-font-size font-color link1"></i>
                  <div>
                    <label class="labels-sf font-color link1">
                      Nurse
                    </label>
                  </div>
                </a>

              </div>
              <div class="col-md-4 border-right text-align-center">
                <a (click)="onSignUpreg()" class="nav-link-hand">
                  <i class="fas fa-user-circle icon-font-size font-color link1"></i>
                  <div>
                    <label class="labels-sf font-color link1">
                      Registry
                    </label>
                  </div>
                </a>

              </div>
              <div class="col-md-4 text-align-center">
                <a (click)="onSignUphos()" class="nav-link-hand">
                  <i class="fas fa-hospital icon-font-size font-color link1"></i>
                  <div class="hospital-icon">
                    <label class="font-color link1">
                      Hospital
                    </label>
                  </div>
                </a>

              </div>
            </div>
            

          </div>
          <label class="margin-top-15px">Already have an account ?<a (click)="onSignIp()" class="nav-link-hand margin-left-10px color5 font-size-16px">Click here to Sign In</a></label>
        </div>
      </div>
    </div>
  </div>
  <!-- Main Container End -->
  <!--Footer start-->

  <!--<footer>
    <div class="row">
      <div class="col-xs-hide col-sm-6 copy-text">&copy; Copyright 2018 RN Cloud. All Rights Reserved</div>
      <div class="col-sm-6 share-bar">
        <ul class="share-buttons">
          <li class="facebook-share"><a title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
          <li class="twitter-share"><a title="Tweet"><i class="fab fa-twitter"></i></a></li>
          <li class="google-share"><a  title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
          <li class="reddit-share"><a  title="Google+"><i class="fab fa-google-plus"></i></a></li>
          <li class="reddit-share"><a  title="Youtube"><i class="fab fa-youtube"></i></a></li>
        </ul>
      </div>
    </div>
  </footer>-->
  <!-- Modal -->
  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <a class="modal-brand"><img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"></a>
          <h4 class="modal-title" id="myModalLabel">Sign In</h4>
        </div>
        <div class="modal-body p-4">
          <div class="row">
            <div class="col-md-12 col-xs-12 login_control">
              <div class="radio-box">
                <label class="radio-inline">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" selected="selected"> Nurse
                </label>
                <label class="radio-inline">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> Registry
                </label>
                <label class="radio-inline">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> Healthcare Organization
                </label>
              </div>
              <div class="control">
                <div class="label">User ID</div>
                <label><i class="input-icon fas fa-user"></i><input type="text" class="form-control" value="" /></label>
              </div>

              <div class="control">
                <div class="label">Password</div>
                <label><i class="input-icon fas fa-key"></i><input type="password" class="form-control" value="" /></label>
              </div>
              <div class="form-group last-row">
                <label class="checklabel"><input type="checkbox"> Remember me</label>
                <a  class="pull-right" data-toggle="modal" data-dismiss="modal" data-target="#myModalforget">Forgot password?</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Sign In</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Sign Up -->
  <div class="modal fade" id="myModalSignup" tabindex="-1" role="dialog"
       aria-labelledby="myModalSignupLabel" aria-hidden="true">
    <div class="modal-dialog modal-signup">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <a  class="modal-brand"><img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"></a>
          <h4 class="modal-title" id="myModalLabel">Sign Up</h4>
        </div>
        <div class="modal-body p-4 ">
          <div class="row">
            <div class="pop-over-scrolling w-auto">
              <div class="row">
                <div class="col-12 col-md-6 login_control">
                  <div class="control">
                    <div class="label">Your Name</div>
                    <label><i class="input-icon fas fa-user"></i><input type="text" class="form-control" value="" /></label>
                  </div>

                  <div class="control">
                    <div class="label">User ID</div>
                    <label><i class="input-icon far fa-user"></i><input type="password" class="form-control" value="" /></label>
                  </div>
                  <div class="control">
                    <div class="label">Your Area</div>
                    <div class="radio-box">
                      <label class="radio-inline">
                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" selected="selected"> Nurse
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> Registry
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> Healthcare Organization
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 login_control">
                  <div class="control">
                    <div class="label">Mobile Number</div>
                    <label><i class="input-icon fas fa-mobile-alt"></i><input type="text" class="form-control" value="" /></label>
                  </div>

                  <div class="control">
                    <div class="label">Email ID</div>
                    <label><i class="input-icon fas fa-envelope"></i><input type="password" class="form-control" value="" /></label>
                  </div>
                  <div class="control">
                    <div class="label">Set Your Password</div>
                    <label><i class="input-icon fas fa-key"></i><input type="password" class="form-control" value="" /></label>
                  </div>
                  <div class="control">
                    <label class="checklabel"><input type="checkbox"> I agree terms and conditions</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Sign Up</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="myModalforget" tabindex="-1" role="dialog" aria-labelledby="myModalforgetLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <a  class="modal-brand"><img src="../../../../../../wwwroot/healins-assets/images/RNCloud_logo.png"></a>
          <h4 class="modal-title" id="myModalLabel">Forgot password</h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12 col-xs-12 login_control">
            <div class="control">
              <div class="label">User ID</div>
              <label><i class="input-icon fa fa-user"></i><input type="text" class="form-control" value="" /></label>
            </div>
            <div class="control signin-control">
              <a >Sign In</a> <a >Sign Up</a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Submit</button>
        </div>
      </div>
    </div>
  </div>
    </div>
    </body>
<!--<footer>
  <div class="row">
    <div class="col-xs-hide col-sm-6 copy-text">&copy; Copyright 2018 RN Cloud. All Rights Reserved</div>
    <div class="col-sm-6 share-bar">
      <ul class="share-buttons" hidden>
        <li class="facebook-share"><a title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
        <li class="twitter-share"><a title="Tweet"><i class="fab fa-twitter"></i></a></li>
        <li class="google-share"><a title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
        <li class="reddit-share"><a title="Google+"><i class="fab fa-google-plus"></i></a></li>
        <li class="reddit-share"><a title="Youtube"><i class="fab fa-youtube"></i></a></li>
      </ul>
    </div>
  </div>
</footer>-->
<footer class="footer margin-top-footer text-align-right">
  <div class="col-md-12 copy-text">&copy; Copyright 2018 RN Cloud. All Rights Reserved</div>
</footer>
